import classNames from 'classnames'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { Title1, Title2 } from '@ui/Typography'
import { Button } from '@ui/components/Button'
import { LogoIcon } from '@ui/icons/LogoIcon'
import { TableEmptyComponent } from '@ui/v2/Table/NoResults/TableNoResults'
import tableStyles from '@ui/v2/Table/Table.module.scss'

import styles from './EmptyPortfolioState.module.scss'

type Props = {
  hasActiveFilters?: boolean
}

export const EmptyPortfolioState: FC<Props> = ({ hasActiveFilters }) => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const handleExploreMarkets = () => {
    navigate('/dashboard/trade/markets')
  }

  return (
    <div className={classNames(tableStyles.tableNoResults, styles.overflowVisible)}>
      <TableEmptyComponent />
      <div className={tableStyles.infoWrapper}>
        <div className={styles.wrapper}>
          <LogoIcon size={48} color='text-med-em' secondaryColor='text-med-em' />
          <div className={styles.textWrapper}>
            <Title1 medium color='text-high-em'>
              {hasActiveFilters
                ? t('Portfolio.No matching trades')
                : t('Portfolio.No trades to display')}
            </Title1>
            <Title2 color='text-med-em'>
              {hasActiveFilters
                ? t('Portfolio.Try adjusting your filters')
                : t('Portfolio.Your portfolio activity will appear here.')}
            </Title2>
          </div>
          {!hasActiveFilters && (
            <div className={styles.buttonWrapper}>
              <Button fullWidth variant='primary' onClick={handleExploreMarkets}>
                {t('Portfolio.Explore markets')}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
